export default {
  seeMoreText: 'Voir plus',
};
